// extracted by mini-css-extract-plugin
export default {"modalHeaderContainer":"QRViewModal_modalHeaderContainer__79TCp","closeModal":"QRViewModal_closeModal__7HEPE","url":"QRViewModal_url__5h0z9"};